import * as $ from "jquery";
import { Grid } from 'ag-grid-community';

export default class SalesDistrictComponent {
    constructor() {
        this.componentSelector = "#sales-districts";
        this.grid = null;
        this.instance = this;
    }

    init() {
        let instance = this;
        if ($(instance.componentSelector).length > 0) {
            instance.bind();
            instance.search(instance);
        }
    }

    bind() {
        let instance = this;
        $('.js-upload-districts').off().on('click', function () {
            $('#sales-districts').addClass('locked');
            instance.upload();
        });

        $('.js-search-districts').off().on('click', function () {
            instance.search(instance);
        });

        $('.js-download-districts').off().on('click', function () {
            instance.download(instance);
        });
    }

    search(instance) {
        let marketId = $('#districts-market').val();
        axios({
            method: 'post',
            url: "/uploadexcel/GetDistrictsByMarket",
            data: { marketId: marketId }
        }).then(function (response) {
            instance.render(instance, response.data);
        }).catch(function () {
            bootbox.alert("Något gick fel vid hämtning av säljdistrikt.");
        });
    }

    render(instance, data) {
        if (instance.grid == null) {
            instance.grid = {
                columnDefs: [
                    { headerName: 'Land', field: 'Country' },
                    { headerName: 'Startnummer', field: 'StartZip' },
                    { headerName: 'Slutnummer', field: 'EndZip' },
                    { headerName: 'Distrikt', field: 'District' },
                    { headerName: 'Säljar-ID', field: 'SellerId' }
                ],
                rowData: data,
                defaultColDef: { sortable: true, filter: true },
                domLayout: 'autoHeight',
                pagination: true,
                paginationPageSize: 50,
            };
            var eGridDiv = document.querySelector('#districts-report');
            new Grid(eGridDiv, instance.grid);
        } else {
            instance.grid.api.setRowData(data);
        }
    }

    upload() {
        var uploadModel = {};
        uploadModel.Files = [];

        var files = $('.dropzone .dz-filename span');
        $.each(files, function () {
            var file = {};
            file.FileName = $(this).html();
            uploadModel.Files.push(file);
        });

        axios({
            method: 'post',
            url: "/uploadexcel/SaveDistricts",
            data: { files: uploadModel }
        }).then(function (response) {
            $('#sales-upload').removeClass('locked');

            if (parseInt(response.data.Failed) == 0) {
                window.location.href = "/SalesDistricts/SalesDistricts";
            }
            else {
                bootbox.alert("Importen hittade ett fel på rad " + response.data.FailedRows + " som gjorde att filen inte kunde läsas in.");
            }

        }).catch(function (error) {
            $('#sales-upload').removeClass('locked');

            var message = "Något gick fel";

            if (error.response && error.response.data && error.response.data.message) {
                message = error.response.data.message;
            }

            bootbox.alert(message);
        });
    }

    download(instance) {
        let marketId = $('#districts-market').val();
        var uri = "/uploadexcel/DownloadDistrictsByMarket?marketId=" + marketId;
        var date = new Date();
        var fileName = "Säljdistrikt-" + date.toISOString().split('T')[0] + ".xlsx";
        var x = new XMLHttpRequest();
        x.open("POST", uri, true);
        x.responseType = "blob";
        x.onload = function (e) { download(e.target.response, fileName, "application/vnd.ms-excel"); };
        x.send();
    }
}